import type { State } from '../State';
import { puzzleWinCountDays } from './puzzleWinCount.ruleset';
import { getJSTDateTime } from '../utils/time';

/**
 * Retrieve the number of days since the last puzzle win
 * @param state
 * @param now
 * @returns
 */
export function getDaysSinceLastPuzzleWin(state: State, now: number): number {
  const today = getJSTDateTime(now).startOf('day');
  const lastUpdate = getJSTDateTime(state.puzzleWinCount.updatedAt).startOf(
    'day',
  );
  return Math.min(today.diff(lastUpdate, 'days').days, puzzleWinCountDays);
}

/**
 * Retrieve the number of puzzle wins in the last days
 * @param state User state
 * @param now Current time
 * @returns Number[] Array of puzzle wins for the last days
 */
export function getPuzzleWinsLast7Days(state: State, now: number): number[] {
  // Clone existing history to not modify the original
  const history = state.puzzleWinCount.days.slice();

  // Add 0 for the missing days
  const maxDays = getDaysSinceLastPuzzleWin(state, now);
  for (let i = 0; i < maxDays; i++) {
    history.unshift(0);
  }

  // Clamp the history length to the maximum allowed
  if (history.length > puzzleWinCountDays) {
    history.length = puzzleWinCountDays;
  }

  // Return the sum of the current day stats and the history stats
  // 0 - Today
  // 1 - Yesterday
  // 2 - 2 days ago
  return history;
}
